module.exports = __webpack_public_path__ + "img/house-fill.775f2bdf.svg";